<template>
  <div>
    <editor-stepper
    />
    <loader v-if="loading"
      :label="$t('editor.elements.loadingElements')"
    />
    <v-container fluid
      v-else
    >
      <v-data-iterator
        :items="elements"
        :items-per-page.sync="itemsPerPage"
        :page.sync="page"
        :search="search"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :footer-props="{
          'items-per-page-options': itemsPerPageArray,
          'items-per-page-text': $t('editor.elements.itemsPerPage'),
          'items-per-page-all-text': $t('editor.elements.itemsPerPageAll')
        }"
      >
        <template v-slot:header>
          <v-toolbar
            class="my-1 elevation-0 raison-highlight"
          >
            <v-btn
              class="raison-btn"
              @click="showNewElementDialog = true"
            >
              {{ $t('editor.element.add') }}
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              clearable
              flat
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="grey"
              autofocus
            ></v-text-field>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>
              <v-select
                v-model="sortBy"
                flat
                hide-details
                :items="keys"
                prepend-inner-icon="mdi-sort"
                item-text="label"
                item-value="value"
                color="grey"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn-toggle
                v-model="sortDesc"
                mandatory
              >
                <v-btn
                  class="ma-0"
                  small
                  :value="false"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
                <v-btn
                  class="ma-0"
                  small
                  :value="true"
                >
                  <v-icon>mdi-arrow-down</v-icon>
                </v-btn>
              </v-btn-toggle>
            </template>
          </v-toolbar>
        </template>

        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <element-chip
                :clickable="true"
                :element="item"
                :show-details="debugMode"
                @elementSelected="onElementSelected(item)"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <element-form
      :open.sync="showElementDialog"
      :element="selectedElement"
      @elementsUpdated="onElementsUpdated"
      @elementsDeleted="onElementsDeleted"
      @elementsCreated="onElementsCreated"
      @raison-event="$emit('raison-event', $event)"
    />
    <element-form
      :open.sync="showNewElementDialog"
      @elementsCreated="onElementsCreated"
      @raison-event="$emit('raison-event', $event)"
    />
  </div>
</template>
<script>
import ElementChip from '@/components/global/ElementChip'
import ElementForm from '@/components/editor/ElementForm'
import EditorStepper from '@/components/editor/EditorStepper'
import Loader from '@/components/global/Loader'

import debugModeMixin from '@/mixins/debug-mode-mixin.js'

import elementService from '@/services/elements.js'
import helpService from '@/services/help.js'

export default ({
  name: 'ElementsList',

  components: {
    ElementChip,
    ElementForm,
    EditorStepper,
    Loader
  },

  mixins: [ debugModeMixin ],

  data () {
    return {
      elements: [],
      projectId: "",
      loading: false,
      itemsPerPageArray: [24, 48, 96, -1],
      search: '',
      filter: {},
      sortDesc: true,
      page: 1,
      itemsPerPage: 24,
      sortBy: 'lastModifiedDate',
      keys: [
        { label: this.$t('editor.elements.sortByName'), value: 'name' },
        { label: this.$t('editor.elements.sortByLastModifiedDate'), value: 'lastModifiedDate' }
      ],
      showElementDialog: false,
      showNewElementDialog: false,
      selectedElement: {},
    }
  },
  
  computed: {
    numberOfPages () {
      return Math.ceil(this.elements.length / this.itemsPerPage)
    },
    filteredKeys () {
      return this.keys.filter(key => key !== 'Name')
    },
  },
  
  methods: {
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number
    },
    loadElements() {
      this.loading = true
      elementService.getElements(this.projectId)
        .then(response => {
          this.elements = response.data
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onElementSelected(element) {
      // console.log('onElementSelected', element)
      this.selectedElement = element;
      this.showElementDialog = true
    },
    onElementsCreated(elementsCreated) {
      this.elements.splice(0, 0, ...elementsCreated)
    },
    onElementsUpdated(elementsUpdated) {
      for(let element of elementsUpdated) {
        const elementIndex = this.elements.findIndex(elt => elt.id === element.id)
        if(elementIndex != -1) {
          this.elements.splice(elementIndex, 1, element)
        }
      }
    },
    onElementsDeleted(elementsDeleted) {
      // console.log('onElementDeleted', elementsDeleted)
      for(let element of elementsDeleted) {
        const elementIndex = this.elements.findIndex(elt => elt.id === element.id)
        if(elementIndex != -1) {
          this.elements.splice(elementIndex, 1)
        }
      }
    }
  },

  created() {
    this.projectId = this.$route.params.id
    helpService.setHelpPage(this.$store, 'manage_elements')
    this.loadElements()
  }
});
</script>
<style scoped>
</style>